template.tips = function () {
	var mq = template.media_query();
	var filter = $('.tips-filter');
	var button = $('.tips-filter__button');

	button.click(function(e) {
		e.preventDefault();
		filter.toggleClass('active');
	});

	if (mq === 'xl') {
		filter.stick_in_parent();
	}
};
